import React from 'react'
import Footer from '../Footer'
import { About1 } from '../About1'

const About = () => {
  return (
    <div>
      <h1 className='services'>About us</h1>
      <section className='heading'>
        {/* <h2>Activities we think you would enjoy</h2> */}
        <div className='services-container'>
          <div className='services-wrapper bg-dark'> 
         
      <About1/>
          </div>
        </div>
      </section>
   
    </div>
  )
}

export default About
